/**
 * CarrecView component.
 * @module components/View/CarrecView
 */
import { Grid } from 'semantic-ui-react';
import RenderBlocks from '@plone/volto/components/theme/View/RenderBlocks';
import { UniversalLink, Image } from '@plone/volto/components';
import { BodyClass, hasBlocksData, flattenToAppURL } from '@plone/volto/helpers';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { isEmpty, map } from 'lodash';
import { Attachments, Map } from '../';
import { getSocialNetworkIcon } from '../../helpers'


const EntityView = (props) => {
  const { content } = props;

  const entitiesLink = content.parent?.['@id'] ? flattenToAppURL(content.parent['@id']) : '';

  const getPosition = function (geolocation) {
    if (!geolocation) {
      return null
    }
    return geolocation.split(';').map(parseFloat);
  }

  const geolocation = getPosition(content.geolocation)

  const getSubjectLink = function (subject) {
    const subjectLink = `${entitiesLink}?category=${subject}`;
    return subjectLink;
  }

  return (
    <>
      <BodyClass className='entity-view smallHeader' />

      <Grid className='entityView'>
        <Grid.Row columns={12}>
          <Grid.Column className='mb-5' mobile={12} table={6} computer={8} widescreen={8} largeScreen={8}>

          {content.preview_image && (
            <Image
              className="entityView__image"
              item={content}
              imageField="preview_image"
              alt=""
              sizes="(max-width: 767px) 100vw, (max-width: 991px) 50vw, 75vw"
            />
          )}

          {/* Volto Blocks */}
          {hasBlocksData(content) ? (
            <div className="userBlocks pt-3">
              <RenderBlocks {...props} />
            </div>
          ) : null}

          </Grid.Column>
          <Grid.Column mobile={12} table={6} computer={4} widescreen={4} largeScreen={4}>
            <dl className="entityView__details">
              {content?.entity_scopes && (
                <div className="entityView__concept">
                  <dt className="entityView__concept__name"><FormattedMessage id="Type" defaultMessage="Type" /></dt>
                  <dd className="entityView__concept__desc">
                    <ul className="list-unstyled my-0 d-flex gap-2 flex-wrap pt-2">
                      {map(content.entity_scopes, (item) => (
                        <li key={item.token} >
                          <UniversalLink href={getSubjectLink(item.token)} className='subjectLabel'>{item?.title}</UniversalLink>
                        </li>
                      ))}
                    </ul>
                  </dd>
                </div>
              )}
              {content?.location && (
                <div className="entityView__concept">
                  <dt className="entityView__concept__name"><FormattedMessage id="Address" defaultMessage="Address" /></dt>
                  <dd className="entityView__concept__desc">{content.location}</dd>
                </div>
              )}
              {content?.telephone && (
                <div className="entityView__concept">
                  <dt className="entityView__concept__name"><FormattedMessage id="Contact phone" defaultMessage="Contact phone" /></dt>
                  <dd className="entityView__concept__desc"><a href={'tel:+34' + content.telephone.replace(/ /g, '')}>{content.telephone}</a></dd>
                </div>
              )}
              {content?.email && (
                <div className="entityView__concept">
                  <dt className="entityView__concept__name"><FormattedMessage id="Email" defaultMessage="Email" /></dt>
                  <dd className="entityView__concept__desc"><a href={'mailto:' + content.email}>{content.email}</a></dd>
                </div>
              )}
              {content?.web && (
                <div className="entityView__concept">
                  <dt className="entityView__concept__name"><FormattedMessage id="Web" defaultMessage="Web" /></dt>
                  <dd className="entityView__concept__desc"><a href={content.web}>{content.web}</a></dd>
                </div>
              )}
              {!isEmpty(content.social_networks) && (
                <div className="entityView__concept">
                  <dt className="entityView__concept__name"><FormattedMessage id="Social Networks" defaultMessage="Social Networks" /></dt>
                  <dd className="entityView__concept__desc">
                    <ul className="list-unstyled entityView__xxss">
                      {map(content?.social_networks?.items, (social_network, index) => (
                        <li className="entityView__xxss__item" key={index}>
                          <a className='entityView__xxss__link fs-6' href={social_network.link}>
                            <FontAwesomeIcon icon={getSocialNetworkIcon(social_network.social_network)} />
                            <span className="visually-hidden">Twitter</span>
                          </a>
                        </li>
                      ))}
                    </ul>
                  </dd>
                </div>
              )}
              {content.web && (
                <div className="entityView__concept">
                  <dt className="entityView__concept__name"><FormattedMessage id="Entity Map" defaultMessage="Entity Map" /></dt>
                  <dd className="entityView__concept__desc">
                    <Map marker={geolocation} center={geolocation} className="mdk" />
                  </dd>
                </div>
              )}


            </dl>

          </Grid.Column>

        </Grid.Row>
      </Grid>

      <Attachments {...content} />
    </>
  );
};

export default EntityView;